// @greenlight-spec: 28-it-dashboard-ui.md
import * as React from 'react';

/**
 * Trails `value` by `delayMs`, settling only once it stops changing. Use it to
 * keep an input responsive while the request it drives fires at typing speed.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = React.useState(value);

  React.useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
